// @ts-nocheck
import React, { SetStateAction, useEffect, useState } from 'react';
import sessionStorageService, {
  SessionStorageKeys,
} from '../../../../services/sessionStorageService';
interface ISearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: SetStateAction<string>) => void;
}

const SearchBar = ({ searchTerm, setSearchTerm }: ISearchBarProps) => {
  useEffect(() => {
    const storedSearchTerm =
      sessionStorageService.get<string>(SessionStorageKeys.CachedSearchString) ?? '';
    setSearchTerm(storedSearchTerm);
  }, []);

  const handleChange = (event: any) => {
    setSearchTerm(event.target.value);
  };

  const clearSearchTerm = () => {
    setSearchTerm('');
  };

  useEffect(() => {
    sessionStorageService.save(SessionStorageKeys.CachedSearchString, searchTerm);
  }, [searchTerm]);

  return (
    <div className="search-container">
      <input
        type="text"
        className="search-bar"
        placeholder="Search tasks"
        value={searchTerm}
        onChange={handleChange}
      />
      <button
        className="clear-search-btn"
        onClick={clearSearchTerm}
        style={{ display: searchTerm ? 'inline' : 'none' }}
      >
        &times;
      </button>
    </div>
  );
};

export default SearchBar;
